import { useDispatch } from "react-redux";
import { useApi } from "../hooks/useApi";
import { setCurrency } from "../redux/currency/actions";
import { ApiSettings } from "./settings";

const Currency = () => {
    const [{ data: { selected_currency: currency } = {} }] = useApi(ApiSettings.get);
    const dispatch = useDispatch();
    dispatch(setCurrency(currency));
    return null;
};

export default Currency;
